module.exports = __webpack_public_path__ + "static/img/w3-5.f35da1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-5.png
// module id = Ok8F
// module chunks = 1